<template>
  <div class="addmore">
    <div class="addmore__header">
      <h1 v-if="routeID" class="medium-title">Edit Voucher</h1>
      <h1 v-else class="medium-title">Add Voucher</h1>
    </div>
    <div class="addmore__content">
      <div class="addmore__content--left">
        <div class="addmore__content__fieldset">
          <div class="addmore__content__fieldset__field">
            <adx-input :label="`Voucher Code *`" :validation="['NotEmpty', 'MinLength:3', 'MaxLength:100']" :value.sync="codeVoucher" :upperCase="true"/>
          </div>
        </div>
        <div class="addmore__content__fieldset">
          <div class="header">
            <span class="subhead strong">Discount</span>
          </div>
          <div class="addmore__content__fieldset__field">
            <adx-input :label="`Fix Amount *`" :validation="['NotEmpty', 'Numeric']" :value.sync="amount"/>
          </div>
        </div>
      </div>
      <div class="addmore__content--right">
        <div class="addmore__content__publish">
          <div class="header">
            <span class="subhead strong">Publish</span>
          </div>
          <div class="addmore__content__publish__fieldset">
            <div class="addmore__content__publish__fieldset__content">
              <div class="addmore__content__publish__fieldset__content--left">
                <span class="subhead">Status</span>
              </div>
              <div class="addmore__content__publish__fieldset__content--right">
                <adx-dropdown :value.sync="status" :type="true" :label="`Status`" :options="defaultStatus" @selected="selectStatus" />
              </div>
            </div>
          </div>
        </div>
        <div class="addmore__content__buttons">
          <button class="btn-block primary paynow not-rounded" 
          @click="routeID ? updateVoucher() : createVoucher()">
            Save
          </button>
          <adx-loading-white v-if="loadingSave" class="loading-circle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import Dropdown from '@/components/Form/SelectDropdown'
import LoadingSpinner from '@/components/Loading/Secondary-white'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-admin-vouchers-add',
  components: {
    'adx-input': Input,
    'adx-dropdown': Dropdown,
    'adx-loading-white': LoadingSpinner,
  },
  props: {

  },
  data() {
    return {
      loadingSave: false,
      routeID: null,
      codeVoucher: '',
      amount: null,
      status: null,
      defaultStatus: [
        {
          id: 0,
          label: `Publish`,
          value: true
        },
        {
          id: 1,
          label: `Draft`,
          value: false
        }
      ]
    }
  },
  computed: {

  },
  watch: {
    codeVoucher: function () {
      this.codeVoucher = this.codeVoucher.toUpperCase()
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    if (this.$route.query.id) {
      this.routeID = this.$route.query.id
      this.getVoucher()
    }
    this.status = this.defaultStatus[0].value
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectStatus(data) {
      this.status = data.item.value
    },
    getVoucher() {
      (async () => {
        const { data } = await api.get(apiV2.adminVoucherDetail(this.routeID), { needToken: true })
        this.codeVoucher = data.code
        this.amount = data.nominal
        this.status = data.is_active
      })();
    },
    createVoucher() {
      (async () => {
        this.loadingSave = true
        const data = {
          code: this.codeVoucher,
          nominal: this.amount,
          is_active: this.status,
        };
        const response = await api.post(apiV2.adminVoucher, data, { needToken: true })
        if (response.status == 201) {
          this.$notify({
            group: 'saved',
            title: 'Voucher created',
            text: this.codeVoucher + ' with amount ' + this.amount + ' has created',
            type: 'success'
          });
          this.codeVoucher = ''
          this.amount = null
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
        this.loadingSave = false
      })();
    },
    updateVoucher() {
      this.loadingSave = true
      const data = {
        code: this.codeVoucher,
        nominal: this.amount,
        is_active: this.status,
      };
      (async () => {
        const response = await api.put(apiV2.adminVoucherDetail(this.routeID),
        data, { needToken: true })
        if (response.status == 200) {
          this.$notify({
            group: 'saved',
            title: 'Voucher updated',
            text: this.codeVoucher + ' with amount ' + this.amount + ' has updated',
            type: 'success'
          });
          this.codeVoucher = ''
          this.amount = null
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
        this.loadingSave = false
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>